<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>资金管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/money_second_out_list')">提现交易记录</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >

          <el-form-item label='代理信息'>
            <el-input
              style="width:500px"
              v-model="filters.title"
              placeholder="请输入姓名或者手机号"
            >

            </el-input>
          </el-form-item>
          <el-form-item
            label="查询时间"
          >
              <el-form-item prop="startTime">
                <el-date-picker
                  type="date"
                  placeholder="选择开始日期"
                  v-model="filters.startTime"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
              <span style="display: inline-block;margin-right: 9px;">-</span>
              <el-form-item prop="endTime">
                <el-date-picker
                  type="date"
                  placeholder="选择结束日期"
                  v-model="filters.endTime"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>

          </el-form-item>
          <el-form-item label="审核类型">
            <el-select
              v-model="filters.status"
              clearable
            >
              <el-option
                label="申请中"
                value="1"
              ></el-option>
              <el-option
                label="申请通过"
                value="2"
              ></el-option>
              <el-option
                label="申请拒绝"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付方式">
            <el-select
              v-model="filters.infoType"
              clearable
            >
              <el-option
                label="支付宝"
                value="2"
              ></el-option>
              <el-option
                label="银行卡"
                value="1"
              ></el-option>

            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>
          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div> -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="username"
            label="用户姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="用户手机号"
          >
          </el-table-column>

          <el-table-column label="用户头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;height:50px"
              >
            </template>
          </el-table-column>

          <!-- :show-overflow-tooltip="true" -->
          <el-table-column
            prop="total_money"
            label="提现金额"
            width="300"
          >
          <template slot-scope="scope">
            {{scope.row.pay_money.toFixed(2)}}(提现金额) - {{scope.row.rate_money.toFixed(2)}}(手续费) = {{scope.row.total_money.toFixed(2)}}
          </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="申请时间"
          >
          </el-table-column>

          <el-table-column
            prop="info_type"
            label="提现账户"
            width="250"
          >
          <template slot-scope="scope">
            <div v-if="scope.row.info_type == 1">银行：<br/>银行名称：{{scope.row.bank_name}}<br/>开户行：{{scope.row.open_bank}}<br/>卡号：{{scope.row.bank_code}}<br/>{{scope.row.bank_username}}</div>
            <div v-if="scope.row.info_type == 2">支付宝：<br/>真实姓名：{{scope.row.zhi_name}}<br/>帐号：{{scope.row.zhi_account}}<br/></div>
          </template>
          </el-table-column>

          <el-table-column
            prop="info_type"
            label="提现类型"
            width="250"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.company_split_status != null">黑名单提现：比例({{ scope.row.split_ratio }},金额：{{ scope.row.company_price }})</span>
            <span v-else>正常提现</span>
          </template>
          </el-table-column>


          <el-table-column
            prop="cash_load"
            label="通联"
            width="250"
          >
          <template slot-scope="scope">
            <div v-if="scope.row.cash_load == 4">提现失败：{{scope.row.info_code}}</div>
            <div v-if="scope.row.cash_load == 1">未提现</div>
            <div v-if="scope.row.cash_load == 2">提现中</div>
            <div v-if="scope.row.cash_load == 3">提现成功</div>
          </template>
          </el-table-column>

          <el-table-column
            prop="status"
            label="审核状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.status == 2"
                type="success"
                disable-transitions
              >审核成功</el-tag>
              <el-tag
                v-if="scope.row.status == 1 && scope.row.cash_load == 1"
                disable-transitions
              >审核中</el-tag>
              <el-tag
                v-if="scope.row.status == 1 && scope.row.cash_load == 4"
                disable-transitions
              >审核中</el-tag>
              <el-tag
                v-if="scope.row.status == 1 && scope.row.cash_load == 2"
                disable-transitions
              >通联提现审核中</el-tag>
              <el-tag
                v-if="scope.row.status == 3"
                type="danger"
                disable-transitions
              >审核失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template v-if="hasPower('50051991') && scope.row.status == 1">
                <el-button
                  @click="upHouseStatus(scope.row,2)"
                  type="text"
                  size="small"
                >通过</el-button>
                <el-button v-if="hasPower('50051991')"
                  @click="upHouseStatus(scope.row,3)"
                  type="text"
                  size="small"
                >拒绝</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>


  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "money_second_out_list",
  created() {},

  data() {
    return {
      listLoading:false,
      picList: [],
      filters: {
        status: null,
        title:null,
        startTime: null,
        userId: null,
        endTime: null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      totalMoney:0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/money_out_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if (that.filters.title) {
        url = url + "&username=" + that.filters.title;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }
      top.location.href = url;
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    upHouseStatus(row, status) {
      if (status == 3) {
        let that = this;
        this.$confirm("确定拒绝吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              outId: row.id,
              status: 3
            };
            API.second_up_cash_out(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "拒绝成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 2) {
        let that = this;
        this.$confirm("确定通过该审核吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              outId: row.id,
              status:2
            };
            API.second_up_cash_out(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "通过成功",
                      duration: 1500
                    });

                  } else if (result && parseInt(result.key) === 9881) {
                    that.$message.success({
                      showClose: true,
                      message: result.message,
                      duration: 1500
                    });

                  } else if (result && parseInt(result.key) === 2334) {
                    that.$message.success({
                      showClose: true,
                      message: result.message,
                      duration: 1500
                    });

                  } else if (result && parseInt(result.key) === 8712) {
                    that.$message.success({
                      showClose: true,
                      message: result.message,
                      duration: 1500
                    });

                  }
                  that.search();
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        firstStatus:2,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.title) {
        params.username = that.filters.title;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }
      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }
      that.listLoading = true;
      API.money_out_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.totalMoney = result.result.data;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i=0; i<result.result.list.length; i++)
                {
                  if (result.result.list[i].cash_rate != null)
                  {
                    result.result.list[i].total_money = result.result.list[i].pay_money * (1 - result.result.list[i].cash_rate);
                    result.result.list[i].rate_money = result.result.list[i].pay_money * result.result.list[i].cash_rate;
                  }
                  else
                  {
                    result.result.list[i].total_money = result.result.list[i].pay_money;
                    result.result.list[i].rate_money = 0;
                  }
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>

.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/money_second_out_list.vue